<template>
  <div class="view-waste-detail-wrap">
    <CRow>
      <CCol sm="8" class="d-flex mb-3 align-items-center">
        <strong>View Waste Requests</strong>
      </CCol>
      <CCol sm="4">
        <CButton
          color="primary"
          class="px-4"
          @click="getExportExcel(ManifestNo)"
          >Export As Excel</CButton
        >
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Waste Details</strong>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CRow>
                <CCol sm="4">
                  <div class="waste-detail-main">
                    <h4>Site Name</h4>
                    <p>{{ Site_Name }}</p>
                  </div>
                  <div class="waste-detail-main">
                    <h4>Manifest No.</h4>
                    <p>{{ ManifestNo }}</p>
                  </div>
                </CCol>
                <CCol sm="4">
                  <div class="waste-detail-main">
                    <h4>Waste Name</h4>
                    <p>{{ Waste_Name }}</p>
                  </div>
                  <div class="waste-detail-main">
                    <h4>Physical Status</h4>
                    <p>{{ Waste_Physical_Status }}</p>
                  </div>
                </CCol>
                <CCol sm="4">
                  <div class="waste-detail-main">
                    <h4>Lifting Date & Time</h4>
                    <p>{{ Request_Date }}</p>
                  </div>
                  <div class="waste-detail-main">
                    <h4>Waste Qty</h4>
                    <p>{{ Quantity }}</p>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Shipment Details</strong>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CRow>
                <CCol sm="4">
                  <div class="waste-detail-main">
                    <h4>Shipment Status</h4>
                    <p>{{ Shipment_status }}</p>
                  </div>
                </CCol>
                <CCol sm="4">
                  <div class="waste-detail-main">
                    <h4>Packaging</h4>
                    <p>{{ Packaging }}</p>
                  </div>
                </CCol>
                <CCol sm="4">
                  <div class="waste-detail-main">
                    <h4>ETA</h4>
                    <p>{{ ResDateTime }}</p>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Vehicle Details</strong>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CRow>
                <CCol sm="3">
                  <div class="waste-detail-main">
                    <h4>Vehicle No.</h4>
                    <p>{{ SAP_VehicleNo }}</p>
                  </div>
                  <div class="waste-detail-main">
                    <h4>Remark</h4>
                    <p>{{ Remarks }}</p>
                  </div>
                </CCol>
                <CCol sm="3">
                  <div class="waste-detail-main">
                    <h4>Truck Type</h4>
                    <p>{{ Trucktype }}</p>
                  </div>
                </CCol>
                <CCol sm="3">
                  <div class="waste-detail-main">
                    <h4>Driver Name</h4>
                    <p>{{ `-` }}</p>
                  </div>
                </CCol>
                <CCol sm="3">
                  <div class="waste-detail-main">
                    <h4>Driver Phone No</h4>
                    <p>{{ `-` }}</p>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Map Details/ Live Tracking </strong>
          </CCardHeader>
          <CCardBody>
            <h5 v-if="Shipment_status == 'DELIVERED'">Transaction Completed</h5>
            <div v-if="!SAP_VehicleNo || SAP_VehicleNo === '-'">
              Vehicle Not Assigned
            </div>
            <template v-else>
              <CForm v-if="Shipment_status !== 'DELIVERED'">
                <CRow>
                  <CCol sm="12">
                    <!-- <div id="mapName" style="height: 270px" /> -->
                    <GmapMap
                      :zoom="7"
                      :center="center"
                      style="width: 100%; height: 400px"
                    >
                      <DirectionsRenderer
                        travelMode="DRIVING"
                        :origin="startLocation"
                        :destination="endLocation"
                      />
                      <!-- <GmapMarker
                      :icon="{
                        url: require('../../assets/images/carmarker.png'),
                      }"
                    /> -->
                      <gmap-custom-marker :marker="startLocation">
                        <img
                          src="../../assets/images/icons8-truck-96.png"
                          height="70"
                          width="70"
                          style="margin-bottom: -16px; margin-left: 10px"
                        />
                        <!-- <my-component></my-component> -->
                      </gmap-custom-marker>
                    </GmapMap>
                  </CCol>
                </CRow>
              </CForm>
            </template>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
  <!--<div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>View Waste Requests</strong>
            <CButton
              color="primary"
              class="px-4"
              @click="getExportExcel(ManifestNo)"
              >Export As Excel</CButton
            >
          </CCardHeader>

          <CCardBody>
            <CForm class="formData waste-form-main">
              <CRow>
                <CCol class="p-0 d-flex mb-3 col-12">
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Site Name</label><br />
                    <strong class="">{{ Site_Name }}</strong>
                  </CCol>
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Manifest No.</label
                    ><br />
                    <strong class="">{{ ManifestNo }}</strong>
                  </CCol>
                </CCol>
              </CRow>
              <CRow>
                <CCol class="p-0 d-flex mb-3 col-12">
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Customer Name</label
                    ><br />
                    <strong class="">{{ Customer_Name }}</strong>
                  </CCol>
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Vehicle No.</label><br />
                    <strong class="">{{ SAP_VehicleNo }}</strong>
                  </CCol>
                </CCol>
              </CRow>

              <CRow>
                <CCol class="p-0 d-flex mb-3 col-12">
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Waste Name</label><br />
                    <strong class="">{{ Waste_Name }}</strong>
                  </CCol>
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Shipment Status</label
                    ><br />
                    <strong class="">{{ Shipment_status }}</strong>
                  </CCol>
                </CCol>
              </CRow>
              <CRow>
                <CCol class="p-0 d-flex mb-3 col-12">
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">ETA</label><br />
                    <strong class="">{{ ResDateTime }}</strong>
                  </CCol>
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Physical Status</label
                    ><br />
                    <strong class="">{{ Waste_Physical_Status }}</strong>
                  </CCol>
                </CCol>
              </CRow>
              <CRow>
                <CCol class="p-0 d-flex mb-3 col-12">
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black"
                      >Lifting Date & Time</label
                    ><br />
                    <strong class="">{{ Request_Date }}</strong>
                  </CCol>
                </CCol>

                <CCol class="p-0 d-flex mb-3 col-12">
                  <CCol md="6" class="col-6">
				<label class="m-0 col-fonts-black">Lifting Time</label><br/>
				<strong class="">{{Request_Time}}</strong>
				   </CCol> -->
  <!-- <CCol md="6" class="col-6">                  
					<label class="m-0 col-fonts-black">Waste Quentity</label><br/>
				  <strong class="">{{Quantity}}</strong>
               </CCol> -->
  <!--</CCol>
              </CRow>
              <CRow> -->
  <!-- <CCol sm="12" class="p-0 d-flex flex-column">               
				  <CCol class="otherOptions col-sm-12 mb-3 p-0 d-flex col-12">
					
						<CCol md="6" class="col-6">
							<label class="m-0 col-fonts-black">Shipment</label><br/>
						  <strong class="">{{Shipment}}</strong>                  
						</CCol>

					   <CCol md="6" class="col-6">
						 <label class="m-0 col-fonts-black">Packaging</label><br/>
						 <strong class="">{{Packaging}}</strong>				
					   </CCol>
					</CCol>
              </CCol> -->
  <!-- <CCol class="otherOptions col-sm-12 mb-3 p-0 d-flex col-12">
				   <CCol md="6" class="col-6">
					  <label class="m-0 col-fonts-black">Texture</label><br/>
					  <strong class="">{{Texture}}</strong>
				   </CCol>

				   <CCol md="6" class="col-6">
					 <label class="m-0 col-fonts-black">Truck Type</label><br/>
					  <strong class="">{{Trucktype}}</strong>

				   </CCol>
			  </CCol> -->
  <!-- <CCol class="otherOptions col-sm-12 mb-3 p-0 d-flex col-12">
				   <CCol md="6" class="col-6">
					  <label class="m-0 col-fonts-black">Latitude</label><br/>
					  <strong class="">{{Latitude}}</strong>
				   </CCol>

				   <CCol md="6" class="col-6">
					 <label class="m-0 col-fonts-black">Longitude</label><br/>
					  <strong class="">{{Longitude}}</strong>

				   </CCol>
			  </CCol> -->
  <!-- </CRow>
              <CRow>
                <CCol class="otherOptions col-sm-12 mb-3 p-0 d-flex col-12">
                  <CCol md="6" class="col-6">
                    <label class="m-0 col-fonts-black">Remarks</label><br />
                    <strong class="">{{ Remarks }}</strong>
                  </CCol>

                  <CCol md="6" class="col-6">
                    <div id="mapName" style="height: 270px" />
                  </CCol>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12">
                  <button
                    aria-pressed="true"
                    type="button"
                    autocomplete="off"
                    class="
                      btn btn-outline-light btn-block
                      active
                      fw-500
                      col-white
                      fs-18
                    "
                    @click="back()"
                  >
                    Back
                  </button>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div>
  </div> -->
</template>
<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";
import DirectionsRenderer from "./DirectionsRenderer";
import GmapCustomMarker from "vue2-gmap-custom-marker";

export default {
  name: "ViewWasteRequest",
  components: {
    DirectionsRenderer,
    "gmap-custom-marker": GmapCustomMarker,
  },
  data() {
    return {
      Site_Name: "",
      Customer_Name: "",
      Waste_Name: "",
      Waste_Physical_Status: "",
      Request_Date: "",
      Request_Time: "",
      Quantity: "",
      Shipment: "",
      Packaging: "",
      Texture: "",
      Trucktype: "",
      Remarks: "",
      ManifestNo: "",
      SAP_VehicleNo: "",
      Shipment_status: "",
      ResDateTime: "",
      Latitude: "",
      Longitude: "",
      isLoading: false,
      // for map
      center: { lat: 45.508, lng: -73.587 },
      currentPlace: "",
      markers: [],
      places: [],
      startLocation: [],
      endLocation: [],
    };
  },
  mounted() {
    $(".counterDiv").hide();
    $(".otherOptions").hide();
    var waste_view_id = localStorage.getItem("waste_view_id");
    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

    var requestInfo = {
      Item_Id: waste_view_id,
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    // console.log(requestInfo);
    var data = JSON.stringify(requestInfo);
    var self = this;
    var config = {
      method: "post",
      url: apiURL + "MasterData/GetWasteRequestDetails",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    axios(config)
      .then((result) => {
        this.isLoading = false;
        console.log(result);
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          console.log(obj[0]);
          console.log("ManifestNo:", obj[0].ManifestNo);

          this.Site_Name = obj[0].Site_Name;
          this.Customer_Name = obj[0].Customer_Name;
          this.Waste_Name = obj[0].Waste_Name;
          this.Waste_Physical_Status = obj[0].Waste_Physical_Status;
          this.Request_Date = obj[0].Request_Date;
          this.Request_Time = obj[0].Request_Time;
          this.Quantity = obj[0].Quantity;
          this.Shipment = obj[0].Shipment;
          this.Packaging = obj[0].Packaging;
          this.Texture = obj[0].Texture;
          this.Trucktype = obj[0].Trucktype;
          this.Remarks = obj[0].Remarks;
          this.ManifestNo = obj[0].ManifestNo;
          this.SAP_VehicleNo = obj[0].SAP_VehicleNo;
        } else {
          //$('#reponse_error').html(result.data.message);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      })
      .catch((error) => {
        this.isLoading = false;
        //var errorObject=JSON.stringify(error.response.data.errors);
        //console.log(errorObject);
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });

    //	get status
    var requestInfo = {
      RequestId: waste_view_id,
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/ShipmentStatusRequestStatus",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    axios(config)
      .then((result) => {
        this.isLoading = false;
        this.Shipment_status = result.data.status;
        console.log("result.data.status:", result.data.status);
      })
      .catch((error) => {
        this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });

    //	get ETA
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/ShipmentETARequestStatus",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    axios(config)
      .then((result) => {
        this.isLoading = false;
        this.ResDateTime = result.data.ResDateTime;
      })
      .catch((error) => {
        this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });

    //	get Lat Long
    var getUserInfo = JSON.parse(localStorage.getItem("user"));
    console.log("getUserInfo----", getUserInfo[0]);
    const myLetLngCust = {
      lat: parseFloat(getUserInfo[0].Latitude),
      lng: parseFloat(getUserInfo[0].Longitude),
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/LatLongRequestStatus",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    window.setInterval(() => {
      axios(config)
        .then((result) => {
          this.isLoading = false;
          this.Latitude = result.data.Latitude;
          this.Longitude = result.data.Longitude;

          // MAP load when long lat get
          const loader = new Loader({
            apiKey: "AIzaSyBTbMcgGot8-R7Rmn7ks6u7PuAeHa-qdB8",
            version: "weekly",
            libraries: ["places"],
          });

          const myLatLng = {
            lat: parseFloat(self.Latitude),
            lng: parseFloat(self.Longitude),
          };
          console.log("myLatLng:", myLatLng);
          // var map = "";
          // loader.load().then(() => {
          //   map = new window.google.maps.Map(document.getElementById("mapName"), {
          //     center: myLatLng,
          //     zoom: 16,
          //     mapTypeId: window.google.maps.MapTypeId.ROADMAP,
          //   });

          //   new window.google.maps.Marker({
          //     position: myLatLng,
          //     map,
          //     title: this.Site_Name,
          //   });
          // });

          // new code -----------------
          const marker1 = myLatLng;

          // var marker12 = [
          //   {
          //     lat: parseFloat("21.1702"),
          //     lng: parseFloat("72.8311"),
          //   },
          //   {
          //     lat: parseFloat("20.3893"),
          //     lng: parseFloat("72.9106"),
          //   },
          //   // {
          //   //   lat: parseFloat("20.9500"),
          //   //   lng: parseFloat("72.9300"),
          //   // },
          //   // {
          //   //   lat: parseFloat("72.911453"),
          //   //   lng: parseFloat("20.385181"),
          //   // },
          //   // {
          //   //   lat: parseFloat("21.1702"),
          //   //   lng: parseFloat("72.8311"),
          //   // },
          //   // {
          //   //   lat: parseFloat("19.6967"),
          //   //   lng: parseFloat("72.7699"),
          //   // },
          // ];
          // var i = 0;
          // setInterval(function () {
          //   this.startLocation = marker12[i];
          //   console.log("every second :---", this.startLocation);
          //   if (i == marker12.length - 1) {
          //     i = 0;
          //     //you can even clear interval here to make heading stay as last one in array
          //     //cleanInterval(intervalId);
          //   } else {
          //     i++;
          //   }
          // }, 10000);

          const marker2 = {
            lat: parseFloat("19.0760"),
            lng: parseFloat("72.8777"),
          };

          const marker3 = {
            lat: parseFloat("20.3893"),
            lng: parseFloat("72.9106"),
          };
          // // if (index === 0)
          this.startLocation = marker1;
          this.endLocation = myLetLngCust;
          // if (index === 1)
          // this.center = marker3;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    }, 2000);
  },
  computed: {},
  methods: {
    validator(val) {
      // return val ? val.length >= 4 : false
    },
    back() {
      console.log("call");
      this.$router.push({ path: "manage_wastes" });
    },

    // Method for the get export excel based on the manifest no
    getExportExcel(ManifestNo) {
      // this.isLoading = true;
      //alert(this.isLoading);
      if (ManifestNo === null || ManifestNo === "") {
        // alert("Manifest no is not exit.");
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Manifest no is not exit!",
        });
      } else {
        this.isLoading = true;
        var requestInfo = {
          Manifest_No: ManifestNo,
        };
        var data = JSON.stringify(requestInfo);
        var config = {
          method: "post",
          // url: apiURL + "MasterData/GetSapSites",
          // url: "https://180.179.23.92/api/ManageManifestApi/GetExportManifestData",
          url: apiURL + "ManageManifestApi/GetExportManifestData",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
          responseType: "arraybuffer",
        };
        this.isLoading = true;
        axios(config)
          .then((response) => {
            //  debugger
            this.isLoading = false;
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            // link.setAttribute("download", ManifestNo + `.xlsx`);
            link.setAttribute("download", ManifestNo + `.xls`);
            document.body.appendChild(link);
            link.click();
            this.isLoading = false;
            console.log(self.isLoading);
          })
          .catch((error) => {
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          });
      }
    },
  },
};
</script>
